module.exports = __webpack_public_path__ + "static/prosthetics_01-525a434afbea63c4906c5690c60389b7.jpg";